import { render, staticRenderFns } from "./purchasingApplication.vue?vue&type=template&id=4fbc7704&scoped=true"
import script from "./purchasingApplication.vue?vue&type=script&lang=js"
export * from "./purchasingApplication.vue?vue&type=script&lang=js"
import style0 from "./purchasingApplication.vue?vue&type=style&index=0&id=4fbc7704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbc7704",
  null
  
)

export default component.exports